import { Box } from '@material-ui/core';
import React from 'react';
import Tag from 'views/ProductManagement/components/Tag';
import classes from './ProductCategoryCell.module.scss';

const ProductCategoryCell = ({ productCategories }) => {
  return (
    <Box className={classes.productCategoryCell} display='flex' flexWrap='wrap' gridGap={8}>
      {(productCategories || []).map(({ id, name, name_en }) => {
        return <Tag key={id} label={name || name_en} />;
      })}
    </Box>
  );
};

export default ProductCategoryCell;
